import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMap2 } from "@tabler/icons-react";
import { RegionesAreasSubareasDef } from "./RegionesAreasSubareasDef";

export const RegionesAreasSubareasIcon = IconMap2;
export const RegionesAreasSubareasHelpText = '* Administrar regiones, areas y subareas.';

export class RegionesAreasSubareas extends Entity<RegionesAreasSubareasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RegionesAreasSubareasDef(), parentKeys);
        this.Form = null;
        this.Title = "Regiones";
        this.HelpText = RegionesAreasSubareasHelpText;
        this.Icon = RegionesAreasSubareasIcon;
    }
}